import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { getCookiesContent } from './Redux/selectors';
import { fetchCookiesContent } from './Redux/thunks';
import CookiesPopup from './CookiesPopup';

interface IPropsInternal {
  content: Julius.Website.CookiesNotificationViewModel;
  fetchCookiesContent: () => void;
}

type Props = IPropsInternal;

interface IState {
  isVisible: boolean;
}

class CookiesPopupContainer extends React.PureComponent<Props, IState> {
  private cookieKey = 'Cookies';
  private cookieKeyWithAds = 'CookiesWithAds';
  private cookieAccepted = 'Accepted';

  constructor(props: Props) {
    super(props);

    this.state = {
      isVisible: false,
    }
  }

  componentDidMount() {
    if (!this.isCookieAccepted()) {
      this.props.fetchCookiesContent();
      this.setState({ isVisible: true });
    } 
  }

  isCookieAccepted = () => {
    const cookiesArr = document.cookie ? document.cookie.split('; ') : [];

    const cookiesMap = cookiesArr.reduce((prev, curr) => {
      const content = curr.split('=');
      if (content.length === 2) {
        prev[content[0]] = content[1];
      }
      return prev;
    }, {});

    return cookiesMap[this.cookieKey] === this.cookieAccepted;
  }

  setAllCookieAccepted = () => {
    const expireDate = new Date();
    expireDate.setTime(expireDate.getTime() + 30*24*60*60*1000);
    document.cookie = `${ this.cookieKey }=${ this.cookieAccepted }; expires=${ expireDate.toUTCString() }; path=/`;
    document.cookie = `${ this.cookieKeyWithAds }=${ this.cookieAccepted }; expires=${ expireDate.toUTCString() }; path=/`;
    window.gtag && window.gtag('consent', 'update', {
      'ad_storage': 'granted'
    });
    window.gtag && window.gtag('consent', 'update', {
      'analytics_storage': 'granted'
    });
    window.gtag && window.gtag('consent', 'update', {
      'ad_user_data': 'granted'
    });
    window.gtag && window.gtag('consent', 'update', {
      'ad_personalization': 'granted'
    });
  }

  setOnlyRequiredCookieAccepted = () => {
    const expireDate = new Date();
    expireDate.setTime(expireDate.getTime() + 30*24*60*60*1000);
    document.cookie = `${ this.cookieKey }=${ this.cookieAccepted }; expires=${ expireDate.toUTCString() }; path=/`;
  }

  onAllOK = () => {
    this.setAllCookieAccepted();
    this.setState({ isVisible: false });
  }

  onRequiredOK = () => {
    this.setOnlyRequiredCookieAccepted();
    this.setState({ isVisible: false });
  }

  render() {
    const { content } = this.props;
    const { isVisible } = this.state;

    if (isVisible && content) {
      return (
        <CookiesPopup 
          content={ content }
          onRequiredOK={ this.onRequiredOK }
          onAllOK={ this.onAllOK } 
        />
      );
    }
    return null;
  }
}
const mapStateToProps = (state: IStore) => {
  return {
    content: getCookiesContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchCookiesContent,
  }, dispatch);
};

export default compose<{}, {}>(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(CookiesPopupContainer);

declare global {
  interface Window {
    gtag?(...arguments: any[]): void;
  }
}


// WEBPACK FOOTER //
// ./src/components/CookiesPopup/CookiesPopupContainer.tsx